export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10193.8147281f.jpg";